import Button from 'components/common/Button';
import useBottomSheet from 'hooks/common/useBottomSheet';
function AlertCanSwipe() {
    const { closeWithAnimation } = useBottomSheet();
    
    return(
        <>
        <div className="flex flex-col w-full items-center rounded-t-lg bg-dialog-bg-default box-shadow-03">
            <div className="flex bg-base-bg-subtle rounded-lg w-full h-[167px] justify-center items-center mb-[20px]">
                <img className="w-[120px] h-[120px] aspect-square flex-shrink-0" alt="can-swipe" src="/imgweb/event/linkle_app_icon.png" />
            </div>
            <div className="flex flex-col align-center gap-[var(--spacing-md)] mb-[var(--spacing-2xl)]">
                <p className='typography-title-md text-dialog-txt-default text-center m-0 w-[243px]'>{brsc.swipe_enabled_title}</p>
                <p className='typography-body-sm  text-dialog-txt-secondary text-center m-0 w-[267px]'>{brsc.swipe_enabled_body}</p>
            </div>
            <Button className='w-full' style={{ text: `${brsc.swipe_btn_1}`, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'lg' }} onClick={() => closeWithAnimation('AlertCanSwipe')} />
            <div className='h-[34px]'/>
        </div>
        </>
    );
}

export default AlertCanSwipe;